export const ImageTypes = [
  "image/jpeg",
  "image/png",
  "image/jpg",
  "image/webp",
];

export const FileTypes = ["application/pdf"];

export const WorkbookTypes = [
  "application/vnd.ms-excel",
  "text/csv",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];

export const AttachmentTypes = [...ImageTypes, ...FileTypes, ...WorkbookTypes];
